import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { GenericObject, OfferType } from '@makemydeal/dr-platform-types';
import { ExtendedOfferTypeEnum, OfferTypeEnum, SpecialPaymentFormula } from '@makemydeal/dr-platform-types';

export const buildPaymentSummary = (
    offerType?: OfferType,
    months?: number,
    apr?: number,
    monthlyPayment?: number,
    offerPrice?: number,
    annualMiles?: number,
    specialPaymentData?: GenericObject
) => {
    if (offerType === OfferTypeEnum.FINANCE && specialPaymentData?.specialPaymentFormula === SpecialPaymentFormula.FordFlexBuy) {
        return buildFlexBuyPaymentSummary(specialPaymentData, apr);
    }

    let summary = '';

    // offer type indicator
    if (offerType === OfferTypeEnum.FINANCE) {
        summary += 'F';
    } else if (offerType === OfferTypeEnum.LEASE) {
        summary += 'L';
    } else if (offerType === OfferTypeEnum.CASH) {
        summary += 'C';
    } else if (offerType === ExtendedOfferTypeEnum.BALLOON) {
        summary += 'B';
    }

    // term
    if (offerType === OfferTypeEnum.FINANCE || offerType === OfferTypeEnum.LEASE || offerType === ExtendedOfferTypeEnum.BALLOON) {
        summary += `${months}`;
    }

    // payment
    if (offerType === OfferTypeEnum.FINANCE || offerType === OfferTypeEnum.LEASE || offerType === ExtendedOfferTypeEnum.BALLOON) {
        summary += ` - ${formatDollarsAndCents(monthlyPayment)}/mo`;
    } else if (offerType === OfferTypeEnum.CASH) {
        summary += ` - ${formatDollarsAndCents(offerPrice)}`;
    }

    // APR finance and balloon
    if (offerType === OfferTypeEnum.FINANCE || offerType === ExtendedOfferTypeEnum.BALLOON) {
        summary += ` @ ${apr}% APR`;
    }

    // annual milage lease only
    if (offerType === OfferTypeEnum.LEASE && annualMiles) {
        summary += ` @ ${(annualMiles / 1000).toFixed(0)}k mi/yr`;
    }

    return summary;
};

export const buildFlexBuyPaymentSummary = (specialPaymentData: GenericObject = {}, apr: number | string = ''): string => {
    const { firstTerm = '', secondTerm = '', firstPaymentAmount, secondPaymentAmount } = specialPaymentData;

    return `FB${firstTerm},${formatDollarsAndCents(firstPaymentAmount)} - FB${secondTerm},${formatDollarsAndCents(
        secondPaymentAmount
    )}/mo @ ${apr}% APR`;
};
